// @flow
import { Badge } from "@mui/material";
import React, { useContext } from 'react';
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { access_news } from "../../../../helpers/rights";
import { TitleContext } from "../../../../pages/main/content";
import Logo from "../../../custom/general/logo/logo";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import PermissionHOC from "../../../../modules/permission/components/permissionHOC/permissionHOC";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import { useTranslation } from "react-i18next";
import { NAVIGATION } from "../../../../locales/components/namespaces";

type Props = {
	mobileOpen: boolean,
	handleDrawerToggle: Function,
	navItems: Array<{
		id: number,
		url: string,
		title: string
	}>
};

const drawerWidth = 300;

const AppDrawer = (props: Props) => {
	const {
		mobileOpen,
		handleDrawerToggle,
		navItems,
	} = props
	const { t } = useTranslation(NAVIGATION)
	const { count } = useContext(TitleContext)
	return (
		<nav>
			<Drawer
				variant="temporary"
				open={mobileOpen}
				onClose={handleDrawerToggle}
				ModalProps={{
					keepMounted: true, // Better open performance on mobile.
				}}
				// sx={{
				// 	display: { xs: 'block', sm: 'block', md: 'none' },
				// 	'& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
				// }}
				sx={{
					display: { xs: 'block', sm: 'block', md: 'none' },
					'& .MuiDrawer-paper': {
						boxSizing: 'border-box',
						width: '100vw',
						maxWidth: drawerWidth,
						paddingTop: 'env(safe-area-inset-top)',
						paddingBottom: 'env(safe-area-inset-bottom)',
						paddingLeft: 'env(safe-area-inset-left)',
						paddingRight: 'env(safe-area-inset-right)',
					},
				}}
			>
				<Box onClick={handleDrawerToggle}
					//  sx={{
					// textAlign: 'center',
					// paddingTop: 'env(safe-area-inset-top)',
					// paddingBottom: 'env(safe-area-inset-bottom)',
					// paddingLeft: 'env(safe-area-inset-left)',
					// paddingRight: 'env(safe-area-inset-right)',
					// boxSizing: 'border-box' }}
					 sx={{
						 textAlign: 'center',
						 width: '100%',
						 height: '100%',
						 boxSizing: 'border-box',
						 display: 'flex',
						 flexDirection: 'column',
						 alignItems: 'center',
						 justifyContent: 'flex-start',
					 }}
				>
					<Logo
						// style={{
						// 	maxWidth: '100px',
						// 	backgroundColor: '#FFFFFF'
						// }}
						style={{
							maxWidth: '100px',
							width: '100%',
							height: 'auto',
							backgroundColor: '#FFFFFF',
							marginTop: '1rem'
						}}
					/>
					<Divider sx={{ width: '100%', my: 2 }}/>
					<List sx={{ width: '100%' }}>
						{navItems.map((item) => item.permissions && item.permissions.length > 0 ? (
							<PermissionHOC
								key={item.id}
								requiredPermissions={[...item.permissions]}>
								<ListItem disablePadding>
									<ListItemButton
										sx={{ textAlign: 'center' }}
										component={Link}
										to={item.url}
									>
										<ListItemText primary={item.title}/>
									</ListItemButton>
								</ListItem>
							</PermissionHOC>
						) : (
							<ListItem key={item.id} disablePadding>
								<ListItemButton
									sx={{ textAlign: 'center' }}
									component={Link}
									to={item.url}
								>
									<ListItemText primary={item.title}/>
								</ListItemButton>
							</ListItem>
						))}
					
					</List>
				</Box>
			</Drawer>
		</nav>
	);
};

export default AppDrawer